<script setup>
import { useI18n } from 'vue-i18n';
import genomaLogo from 'dashboard/assets/images/operacao-imobiliaria/genoma-logo.png';

defineProps({
  activeLabel: { type: String, default: '' },
  pageTitle: { type: String, required: true },
  roleLabel: { type: String, required: true },
});
const { t } = useI18n();
</script>

<template>
  <header
    data-test="sales-party-registration-header"
    :aria-label="`${pageTitle} — ${roleLabel} — ${activeLabel}`"
    class="flex h-[66px] shrink-0 items-center justify-between border-b border-[#DCE3E6] bg-white px-4 font-roboto min-[701px]:px-4"
  >
    <div class="flex h-full items-center gap-7">
      <img
        data-test="sales-party-registration-logo"
        :src="genomaLogo"
        alt="Genoma"
        class="h-[35px] w-auto"
      />
      <span
        class="hidden h-[38px] w-px bg-[#DCE3E6] min-[701px]:block"
        aria-hidden="true"
      />
    </div>

    <div
      class="hidden items-center gap-9 text-base font-bold text-[#263238] min-[701px]:flex"
    >
      <span class="flex items-center gap-2">
        <span class="i-lucide-bell size-4 text-[#009F94]" aria-hidden="true" />
        {{ t('SALES_PARTIES.REGISTRATION.NOTIFICATIONS') }}
      </span>
      <span class="flex items-center gap-2">
        <span
          class="i-lucide-user-round size-4 text-[#009F94]"
          aria-hidden="true"
        />
        {{ t('SALES_PARTIES.REGISTRATION.MY_PROFILE') }}
      </span>
    </div>
  </header>
</template>
